export default "__VITE_ASSET__BdHUARhM__"